//component for job details

import React, { useState, useEffect, useContext } from "react";
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { Row, Col, Form } from 'react-bootstrap';
import "Pages/SkillsBridger/SbSkillsMap.scss"
import Table from 'react-bootstrap/Table';
import * as changeCase from "change-case";
import { JobDataContext } from "State/JobsDataContext";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from "State/AuthContext";
import Permission from "Components/Permission";
//import BubbleChart from "Components/SbBubbleChart/bubblechart-victory";
import BubbleChart from "Components/SbBubbleChart/customBubbleChart";

const SbSkillsMap = () => {

  const { email, accessToken } = useContext(AuthContext);

  const navigate = useNavigate();
  const { selectedJob } = useContext(JobDataContext);
  const jobData = selectedJob;

  const [activeTab, setActiveTab] = useState('skills-bridger');
  const [selectedJdTab, setSelectedJdTab] = useState("skill-map");

  const [selectedSbTab, setSelectedSbTab] = useState("skill-map");

  const [showSkillsDropdown, setShowSkillsDropdown] = useState(false);

  const handleOnBackClick = () => {
    navigate(`/skills-bridger`);
  };


  // function to handle the tab selection
  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey);
    if (tabKey !== "skills-bridger") {
      setSelectedJdTab('skills-bridger');
    }
  };

  // function to handle the tab selection in jobs library tab.
  const handleSelectedSbTab = (e) => {
    setSelectedSbTab(e.target.value);
  };


  const allSkills = [
    { label: 'Technical Proficiency', requiredProficiency: 10, currentProficiency: 4, importance: 3 },
    { label: 'Communication', requiredProficiency: 10, currentProficiency: 4, importance: 3 },
    { label: 'Financial Management', requiredProficiency: 6, currentProficiency: 10, importance: 6 },
    { label: 'Analytical & Problem-solving', requiredProficiency: 10, currentProficiency: 7, importance: 12 },
    { label: 'Leadership & Team Management', requiredProficiency: 8, currentProficiency: 2, importance: 24 },
    { label: 'Project Management', requiredProficiency: 9, currentProficiency: 5, importance: 20 },
    { label: 'Creativity', requiredProficiency: 6, currentProficiency: 4, importance: 9 },
    { label: 'Time Management', requiredProficiency: 10, currentProficiency: 3, importance: 15 },
    { label: 'Strategic Thinking', requiredProficiency: 7, currentProficiency: 7, importance: 29 },
    { label: 'Negotiation Skills', requiredProficiency: 5, currentProficiency: 8, importance: 2 },
    { label: 'Conflict Resolution', requiredProficiency: 6, currentProficiency: 4, importance: 14 },
    { label: 'Customer Focus', requiredProficiency: 7, currentProficiency: 5, importance: 18 },
    { label: 'Adaptability', requiredProficiency: 9, currentProficiency: 9, importance: 21 },
    { label: 'Data Analysis', requiredProficiency: 6, currentProficiency: 2, importance: 13 },
    { label: 'Risk Management', requiredProficiency: 4, currentProficiency: 6, importance: 5 },
    { label: 'Decision Making', requiredProficiency: 8, currentProficiency: 4, importance: 16 },
    { label: 'Innovation', requiredProficiency: 9, currentProficiency: 5, importance: 30 },
    { label: 'Collaboration', requiredProficiency: 5, currentProficiency: 3, importance: 10 },
    { label: 'Emotional Intelligence', requiredProficiency: 7, currentProficiency: 7, importance: 8 },
    { label: 'Technical Writing', requiredProficiency: 10, currentProficiency: 9, importance: 22 },
    { label: 'Business Acumen', requiredProficiency: 6, currentProficiency: 3, importance: 19 }
  ];

  const [showAll, setShowAll] = useState(false);

  const toggleSkills = () => setShowAll(prev => !prev);

  const skillsToShow = showAll ? allSkills : allSkills.slice(0, 5);

  return (
    <Card className='border-0 rounded-0 shadow-sm'>
      <Card.Body>

        <div className="d-flex align-items-center">
          <Button variant="link" onClick={handleOnBackClick} className="me-3">
            {/* Back icon */}
            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_1478_14276)">
                <path d="M29.334 11L4.88954 11" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11 4.58203L4.58333 10.9987L11 17.4154" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
              </g>
              <defs>
                <clipPath id="clip0_1478_14276">
                  <rect width="24" height="22" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                </clipPath>
              </defs>
            </svg>
          </Button>
          <Card.Title className="text-start jobs-heading">
            Employee : XYZ
            <small className="text-body-tertiary jobs-description ms-3">
              Sales Manager, BU1, New York City, Job Grade 4
            </small>
          </Card.Title>
        </div>

        {/* Custom Tabs with divs */}
        <div className="custom-tabs mb-3">
          <div className="tab-titles">
            <div
              className={`tab-title ${activeTab === 'jd' ? 'active' : ''}`}
              onClick={() => handleTabClick('jd')}
            >
              Jobs Library
            </div>
            <div className="d-flex position-relative">
              <div
                className={`tab-title ${activeTab === "skills-bridger" ? "active" : ""} skills-bridger-tab`}
                onClick={() => {
                  setActiveTab("skills-bridger");
                  setShowSkillsDropdown((prev) => !prev);
                }}
                style={{ cursor: "pointer" }}
              >
                Skills Bridger
                <svg
                  className={showSkillsDropdown ? "dropdown-arrow open" : "dropdown-arrow"}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 6.5C12 6.22 11.78 6 11.5 6H4.5C4.22 6 4 6.22 4 6.5C4 6.63 4.05 6.74 4.13 6.83L7.63 10.83C7.72 10.93 7.85 11 8 11C8.15 11 8.28 10.93 8.37 10.83L11.87 6.83C11.95 6.74 12 6.63 12 6.5Z"
                    fill="#8F95B2"
                  />
                </svg>
              </div>
              {activeTab === "skills-bridger" && showSkillsDropdown && (
                <div className="skills-bridger-dropdown">
                  <div
                    className="dropdown-item"
                    onClick={() => {
                      setShowSkillsDropdown(false);
                      navigate("/skills-bridger/employee-skills-proficiency");
                    }}
                  >
                    Skills Proficiency
                  </div>
                  <div
                    className="dropdown-item"
                    onClick={() => {
                      setShowSkillsDropdown(false);
                      // already on this page, so do nothing or reload if needed
                    }}
                  >
                    Skills Map
                  </div>
                </div>
              )}
            </div>

            <div
              className={`tab-title ${activeTab === 'learning-catalyst' ? 'active' : ''} `}
              onClick={() => handleTabClick('learning-catalyst')}
              style={{ cursor: 'pointer' }}
            >
              Learning Catalyst
            </div>

            <div
              className={`tab-title ${activeTab === 'talent-mobility' ? 'active' : ''} `}
              onClick={() => handleTabClick('talent-mobility')}
              style={{ cursor: 'pointer' }}
            >
              Talent Mobility
            </div>

          </div>

          {/* Tab Content */}
          <div className="tab-content">
            {activeTab === 'skills-bridger' && (
              <div className="tab-pane">
                {activeTab === 'skills-bridger' && (
                  <div className="tab-pane">
                    <Row>
                      {/* Left: Bubble Chart */}
                      <Col md={8}>

                        <div className="text-center p-4">
                          <h2 className="mb-2">Employee Skills Map
                          </h2>
                          <p className="">(Bubble size shows skill proficiency required for the role)
                          </p>
                        </div>
                        <div className="text-center py-4 bubble-chart-container">
                          <BubbleChart skills={skillsToShow} />
                          <p className="text-start">
                            Skills Detected = {allSkills.length}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="p-4 text-start">
                            <p className="">
                              *Importance of Skill = Importance of task for the role X Importance of skills for the task
                            </p>

                            <p className="text-start">
                              #Proficiency Gap = Skills needed for role - Skills possessed by employee/s
                            </p>

                            <p className="text-start">
                              ^Skills Bridger Readiness Index = Skills possessed / Skills required
                            </p>

                          </div>
                          <Button
                            className="btn btn-primary btn-md create-button btn-large"
                            onClick={toggleSkills}
                          >
                            {showAll ? 'Show top 5 skills' : 'View All skills'}
                          </Button>
                        </div>

                      </Col>

                      {/* Right: Profile & Info Boxes */}
                      <Col md={4}>
                        {/* Skills Bridger Readiness Index Box */}
                        <Card className="mb-3 shadow  border-0 box-margin-right mt-4">
                          <Card.Body>
                            <div className="d-flex justfy-content-between align-items-center">
                              <p className="p-4 skillsbridger-index-text">SKILLSBRIDGE READINESS INDEX^ FOR SELECTED EMPLOYEE
                              </p>
                              <p className="p-4 skillsbridger-index-text">85%
                              </p>
                            </div>

                          </Card.Body>
                        </Card>

                        {/* Employee Profile Box */}
                        <Card className="mb-3 shadow border-0 box-margin-right profile-box">
                          <Card.Body>
                            <p className="text-center mb-2 ">EMPLOYEE PROFILE</p>
                            <p className="mb-5 text-start">
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                            </p>
                            <p className="text-start">
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                            </p>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                )}

              </div>
            )}
            {activeTab === 'learning-catalyst' && (
              <div className="tab-pane">
                <p>Coming Soon..</p>
              </div>
            )}
            {activeTab === 'talent-mobility' && (
              <div className="tab-pane">
                <p>Coming Soon..</p>
              </div>
            )}
          </div>
        </div>
      </Card.Body>

    </Card >

  );
};

export default SbSkillsMap;
